import { schema } from 'normalizr';
import sharepointFileSchema from './sharepointFile';

const sharepointRootSchema = new schema.Entity('sharepointRoots', {
  files: new schema.Array(sharepointFileSchema),
});

export default sharepointRootSchema;
